// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__sKRag","errorLogs":"styles_errorLogs__1OcS4"};